export default class BioAccordion {
	static TOGGLE_ITEM_SELECTOR = '.et_pb_accordion_closeable .et_pb_toggle.et_pb_accordion_item';
	static TOGGLE_SELECTOR = '.et_pb_accordion_closeable .et_pb_toggle.et_pb_accordion_item .fl-accordion-button';

	start() {
		if (!$(BioAccordion.TOGGLE_ITEM_SELECTOR).length) {
			return;
		}
		this.attachListeners();
	}

	attachListeners() {
		this.toggleExpand();
	}

	toggleExpand() {
		const $ = jQuery;
		$(window).load(() => {
			$(BioAccordion.TOGGLE_SELECTOR).on('keypress', (event) => {
				if (event.which === 13 || event.which === 32) {
					$(this).trigger('click');
				}
			});

			$(BioAccordion.TOGGLE_ITEM_SELECTOR).each(function (index) {
				const toggle = $(this);
				toggle.closest('div').children().first().removeAttr('role');
				const title = toggle.find('.et_pb_toggle_title');
				const titleContent = title.text();
				let ariaExpandValue;
				const panel = toggle.find('.et_pb_toggle_content');
				if (toggle.hasClass('et_pb_toggle_open')) {
					ariaExpandValue = 'true';
				} else {
					ariaExpandValue = 'false';
				}

				$(title).replaceWith(`<h3 class='fl-accordion-heading et_pb_toggle_title'>
				<button type='button' class='fl-accordion-button' aria-expanded=${ariaExpandValue} aria-controls=et_pb_toggle_content_${index}>
                <span class='accordion-title'>
                  ${titleContent}
                  <span class='accordion-icon' aria-hidden='true'></span>
                </span>
              </button>
				</h3>`);
				panel.attr('id', `et_pb_toggle_content_${index}`);
			});

			$(BioAccordion.TOGGLE_SELECTOR).on('click', function () {
				const clickedToggleElement = $(this);
				// Make the accordions closable and set the aria attributes on the clicked toggle
				const clickedToggle = $(this).closest('.et_pb_toggle');
				if (clickedToggle.hasClass('et_pb_toggle_open')) {
					clickedToggle.find('.et_pb_toggle_content').slideToggle(700, () => {
						clickedToggle.removeClass('et_pb_toggle_open').addClass('et_pb_toggle_close');
					});
					clickedToggleElement.attr('aria-expanded', 'false');
				} else {
					clickedToggleElement.attr('aria-expanded', 'true');
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/divi/controllers/bio-accordion.js